/* ==========================================================================
   Unit toggle for a numeric facet — oz ⇄ g on the lure weight filter.

   Display only. The filter values are opaque Shopify GIDs
   (`gid://shopify/FilterSettingGroup/119374008`), not the label text, so
   rewriting a label cannot affect what the link filters. Nothing about the
   catalogue changes: GZ pour in ounces and `custom.weight_oz` stays in ounces.

   Every label keeps its server-rendered text in `data-unit-original`, and each
   conversion is computed from that rather than from whatever is on screen —
   converting an already-converted string is how these drift.

   With JS off the facet is exactly what Shopify rendered: ounces, no toggle.
   ========================================================================== */

(function () {
  'use strict';

  var STORE_KEY = 'ef-unit-pref';

  function readPref() {
    try {
      return localStorage.getItem(STORE_KEY);
    } catch (e) {
      return null; // Safari private mode throws rather than returning null
    }
  }

  function writePref(value) {
    try {
      localStorage.setItem(STORE_KEY, value);
    } catch (e) {
      /* preference simply will not persist */
    }
  }

  function convertText(text, factor, round, from, to) {
    // Only the numbers move. "Under 5 oz" -> "Under 140 g", "5 – 8 oz" ->
    // "140 – 225 g". A label with no digits is left alone rather than mangled.
    var out = text.replace(/\d+(?:\.\d+)?/g, function (n) {
      var v = parseFloat(n) * factor;
      if (round > 0) v = Math.round(v / round) * round;
      else v = Math.round(v);
      return String(v);
    });

    // Word-boundary replace so "oz" inside another word survives.
    var unit = new RegExp('\\b' + from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'gi');
    return out.replace(unit, to);
  }

  /* Config lives on the facet, but convertible labels do not all live inside it
     — the active-filter chips sit in a different part of the page and must read
     in the same unit, or the rail and the chip describe one filter two ways and
     it looks like the filtering broke. So: read the config from the first
     group, then convert every marked label in the document.

     The trade-off is one unit scheme per page. That is the honest limit of this
     control, and a second scheme would need the config moved onto each label. */
  function applyAll(useConverted) {
    var group = document.querySelector('[data-unit-group]');
    if (!group) return;

    var factor = parseFloat(group.getAttribute('data-unit-factor')) || 1;
    var round = parseFloat(group.getAttribute('data-unit-round')) || 0;
    var from = group.getAttribute('data-unit-from') || '';
    var to = group.getAttribute('data-unit-to') || '';

    var targets = document.querySelectorAll('[data-unit-original]');
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      var original = el.getAttribute('data-unit-original');
      el.textContent = useConverted ? convertText(original, factor, round, from, to) : original;
    }

    var buttons = document.querySelectorAll('[data-unit-btn]');
    for (var j = 0; j < buttons.length; j++) {
      var isConverted = buttons[j].getAttribute('data-unit-btn') === 'to';
      buttons[j].setAttribute('aria-pressed', String(isConverted === useConverted));
    }
  }

  function init() {
    if (!document.querySelector('[data-unit-group]')) return;

    // The rail and the mobile filter drawer each render their own copy of the
    // facet, so a click in one has to move both or they disagree on screen.
    var pref = readPref();
    applyAll(pref === 'to');

    document.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('[data-unit-btn]') : null;
      if (!btn) return;
      event.preventDefault();
      var mode = btn.getAttribute('data-unit-btn');
      writePref(mode);
      applyAll(mode === 'to');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
